$('a').each(function() {
    if (!$(this).attr('download') &&
        ($(this).attr('href') &&
        ($(this).attr('href').indexOf('http://') === 0 ||
        $(this).attr('href').indexOf('https://') === 0 ||
        $(this).attr('href').indexOf('.pdf') > 0)))
    {
        if ($(this).attr('data-auto-blank') && $(this).attr('data-auto-blank') === 'off') {
            $(this).removeAttr('target');
        } else {
            $(this).attr('target', '_blank');
        }
    }
});
